export default {
  result: [
    {
      id: '1',
      selection: 'Sélectionner cette option1',
      selectionActive: 'Sélectionner cette option Active',
      title: 'Studio pour 2 personnes',
      features: {
        people: 'x2',
        area: '28m2',
      },
      details: 'Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort (…)',
      discount: 'Tarif membre -10%',
      from: 'From',
      price: '2265',
      priceCent: '20€',
      oldPrice: '2276.20€',
      specialOfferLabel: 'OFFRE SPÉCIALE',
      specialOfferPercent: 14,
      memberOfferLabel: 'Tarif membre -5%',
      priceText: 'Prix le plus bas pour 23 nuits',
      availableText: 'Plus que 7 disponibles',
      popup: {
        fullDescription: 'Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort',
        images: [
          {
            src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
            title: 'title',
          },
          {
            src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
            title: 'title',
          },
          {
            src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
            title: 'title',
          },
        ],
      },
      firstImage: {
        title: '',
        src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
      },
      images: [
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      roomRates: [
        {
          id: 'abc',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '103',
          priceCent: '20€',
          oldPrice: '222.02€',
          discountedPublicPrice: '252',
          discountedPublicPriceCent: '00€',
          publicPrice: '336.00€',
          specialOfferLabel: 'OFFRE SPÉCIALE',
          specialOfferPercent: 25,
          memberOfferLabel: 'Tarif membre -5%',
          redLabel: true,
          features: [
            {
              title: '',
              style: '',
              icon: 'icon-CLOCK',
              highlighted: true,
              cancellation_date: '01/12/20 17:00',
              cancellation_label: 'Annulation gratuite jusqu’au'
            },
            {
              title: 'Paiement à l’aparthotel',
              style: '',
              icon: 'icon-CARD',
              highlighted: true
            },
            {
              title: 'Petit-déjeuner inclus',
              style: '',
              icon: 'icon-BREAKFAST',
              highlighted: true
            }
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 4%',
        },
        {
          id: 'def',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          specialOfferLabel: 'OFFRE SPÉCIALE',
          specialOfferPercent: '25%',
          features: [
            {
              title: 'Paiement sur place',
              style: '',
            },
            {
              title: 'Petit déjeuner inclus',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 30%',
        },
        {
          id: 'ghj',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          features: [
            {
              title: 'Paiement sur place',
              style: '',
            },
            {
              title: 'Petit déjeuner inclus',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 40%',
        },
      ],
    },
    {
      id: '2',
      selection: 'Sélectionner cette option2',
      selectionActive: 'Sélectionner cette option1',
      title: 'Studio pour 2 personnes Studio pour 2 personnes Studio pour 2 personnes Studio pour 2 personnes Studio pour 2 personnes Studio pour 2 personnes Studio pour 2 personnes Studio pour 2 personnes',
      features: {
        people: 'x2',
        area: '28m2',
      },
      details: 'Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort (…)',
      discount: 'Tarif membre -10%',
      from: 'From',
      price: '2265',
      priceCent: '20€',
      oldPrice: '2276.20€',
      priceText: 'Prix le plus bas pour 23 nuits',
      availableText: 'Plus que 7 disponibles',
      popup: {
        fullDescription: 'Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort',
        images: [
          {
            src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
            title: 'title',
          },
          {
            src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
            title: 'title',
          },
          {
            src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
            title: 'title',
          },
        ],
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      roomRates: [
        {
          id: 'abc',
          backRolledId: 'cba',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          redLabel: true,
          features: [
            {
              title: 'Paiement sur place',
              style: '',
              highlighted: true,
            },
            {
              title: '',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite. <a href="#create-account" class="create-account">when you become a free member</a>',
          commission: 'commission 30%',
        },
        {
          id: 'def',
          backRolledId: 'ed',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          features: [
            {
              title: 'Paiement sur place',
              style: '',
            },
            {
              title: 'Petit déjeuner inclus',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 3%',
        },
        {
          id: 'ghj',
          backRolledId: 'hg',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          features: [
            {
              title: 'Paiement sur place',
              style: '',
            },
            {
              title: 'Petit déjeuner inclus',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 10%',
        },
      ],
    },
    {
      id: '3',
      selection: 'Sélectionner cette option3',
      selectionActive: 'Sélectionner cette option1',
      title: 'Studio pour 2 personnes',
      features: {
        people: 'x2',
        area: '28m2',
      },
      details: 'Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort (…)',
      discount: 'Tarif membre -10%',
      from: 'From',
      price: '2265',
      priceCent: '20€',
      oldPrice: '2276.20€',
      priceText: 'Prix le plus bas pour 23 nuits',
      availableText: 'Plus que 7 disponibles',
      popup: {
        fullDescription: 'Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort Lit double, cuisine équipée, salle de bain avec baignoire, coffre-fort',
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      roomRates: [
        {
          id: 'abc',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          redLabel: true,
          features: [
            {
              title: 'Paiement sur place',
              style: '',
              highlighted: true,
            },
            {
              title: '',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 30%',
        },
        {
          id: 'def',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          features: [
            {
              title: 'Paiement sur place',
              style: '',
            },
            {
              title: 'Petit déjeuner inclus',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 20%',
        },
        {
          id: 'ghj',
          title: 'Non flexible',
          subTitle: 'Prépayez votre séjour et bénéficiez de notre meilleur tarif !',
          price: '2103',
          priceCent: '20€',
          oldPrice: '2222.02€',
          features: [
            {
              title: 'Paiement sur place',
              style: '',
            },
            {
              title: 'Petit déjeuner inclus',
              style: 'color: #3A8A6B;font-style: normal',
            },
          ],
          content: 'Non inclus : Taxe municipale et locale : 2.30 EUR (par personne / par nuit)Taxe départementale : 0.23 EUR (par personne / par nuit)',
          club: {
            title: 'ALL - Accor Live Limitless',
            img: '',
          },
          saving: 'Économisez 76€ sur votre réservation (avantage membre). L’adhésion est gratuite.',
          commission: 'commission 11%',
        },
      ],
    },
  ],
  dataLayer: {
    brandcontext: 'ADAGIO',
    language: 'en',
    pagename: null,
    currencycode: 'EUR',
    userconsent: true,
    JSESSIONID: 'InQxfYZxGWiltOmLn8c-cqLVRIUcAACET8gLmpa4ATc',
    'Basket ID': '6988-3114c815-adc5-4cb9-91c6-5aa1f0d94d3c',
    'User agent': 'Mozilla 5.0 (X11; Linux x86_64) AppleWebKit 537.36 (KHTML, like Gecko) Chrome 65.0.3325.181 Safari 537.36',
    uilogged: false,
    loyaltycardtypes: [],
    hotelbrandcode: 'ADG',
    hotelbrandname: 'ADAGIO',
    hotelcode: '6988',
    hotelname: 'Aparthotel Adagio Paris Opera',
    hotelcurrencycode: 'EUR',
    hotelstarnumber: 4,
    hoteladdress: '43 Rue Caumartin 75009 PARIS',
    hotelcitycode: 'SI40',
    hotelcityname: 'PARIS',
    hotelcountrycode: 'FR',
    hotelcountryname: 'FRANCE',
    hoteltripadvisorrating: 4,
    'Reviews provider': 'TRIPADVISOR',
    searchcriteriaarrivaldate: '17-09-2018',
    searchcriterianumbernights: '1',
    searchcriteriadeparturedate: '18-09-2018',
    searchcriterianumberrooms: 1,
    searchcriterianumberadult: 1,
    searchcriterianumberchildren: 0,
    searchcriteriadestination: 'Paris, France',
  },
  prefilledData: {
    roomId: '1',
    roomRateId: 'abc',
    optionId: [1, 2],
  },
}
